import i18n from 'i18n';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from 'shared/commonGrid/grid-enums';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { CfFtpInfo } from 'data/cfFtpInfo/cfFtpInfo.types';
import { ftpTypeValueGetter, fileModeValueGetter } from './utils/cfFtpInfoTemplateValueGetter';

export enum DistributorMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newCfFtpInfo: CfFtpInfo = {
  id: '',
  FTPID: '',
  IPADDR: '',
  PORT: '',
  USERNAME: '',
  USERPASSWD: '',
  DESTPATH: '',
  OPERATORID: '',
  FTPFILESIZE: '',
  FTPFILESEC: '',
  FILEMODE: 'ALLINONE',
  FTPTYPE: 'FTP',
  OWNER: '',
  GROUP: '',
  ACCESS: ''
};

export const distributorColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('cfFtpInfo.grid.FTPID'),
    field: 'FTPID',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'FTPID',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
  },
  {
    headerName: i18n.t('cfFtpInfo.grid.IPADDR'),
    field: 'IPADDR',
    sortable: true,
    resizable: true,
    tooltipField: 'IPADDR',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  {
    headerName: i18n.t('cfFtpInfo.grid.PORT'),
    field: 'PORT',
    sortable: true,
    resizable: true,
    tooltipField: 'PORT',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  {
    headerName: i18n.t('cfFtpInfo.grid.USERNAME'),
    field: 'USERNAME',
    sortable: true,
    resizable: true,
    tooltipField: 'USERNAME',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  {
    headerName: i18n.t('cfFtpInfo.grid.FTPTYPE'),
    field: 'FTPTYPE',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'FTPTYPE',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    valueGetter: ftpTypeValueGetter,
  },
  {
    headerName: i18n.t('cfFtpInfo.grid.FILEMODE'),
    field: 'FILEMODE',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'FILEMODE',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    valueGetter: fileModeValueGetter,
  },
];
